import React, { useState } from "react";

const DISPLAY_LIMIT = 3;

const formatTextWithLineBreaks = text => {
	if (!text) return "No response text";

	return text.split("\n").map((line, index, array) => (
		<React.Fragment key={index}>
			{line}
			{index < array.length - 1 && <br />}
		</React.Fragment>
	));
};

const OpenEndedResponses = ({ question, responses }) => {
	const [showAll, setShowAll] = useState(false);
	const responsesList = responses || [];

	// Sort responses by date (most recent first)
	const sortedResponses = responsesList.sort((a, b) => {
		const dateA = a.responseDate ? a.responseDate.seconds : 0;
		const dateB = b.responseDate ? b.responseDate.seconds : 0;
		return dateB - dateA; // Descending order (most recent first)
	});

	const displayLimit = DISPLAY_LIMIT;

	const displayedResponses = showAll ? sortedResponses : sortedResponses.slice(0, displayLimit);

	return (
		<div className="chart-container open-ended-results">
			<div className="chart-header">
				<h4>{question.title}</h4>
				{question.subtitle && <p className="chart-subtitle">{question.subtitle}</p>}
			</div>

			<div className="item">
				{displayedResponses.length === 0 ? (
					<p className="no-data-message">{"No responses yet."}</p>
				) : (
					<div className="response-list">
						{displayedResponses.map((response, index) => (
							<div key={response.uid || index} className="response-item">
								<p className="response-text">
									{response.response && response.response.length > 0
										? formatTextWithLineBreaks(response.response[0])
										: "No response text"}
								</p>

								{(response.firstName || response.lastName) && (
									<div className="user-info">
										— {response.firstName} {response.lastName}
									</div>
								)}

								{response.attendeeNumber && (
									<div className="user-info">{`Attendee Number: ${response.attendeeNumber}`}</div>
								)}

								{response.responseDate && (
									<div className="response-date">
										{new Date(response.responseDate.seconds * 1000).toLocaleString(undefined, {
											year: "numeric",
											month: "short",
											day: "numeric",
											hour: "2-digit",
											minute: "2-digit",
										})}
									</div>
								)}
							</div>
						))}
					</div>
				)}
			</div>

			{responsesList.length > displayLimit && (
				<div className="show-more-controls">
					<button
						onClick={() => setShowAll(!showAll)}
						className={`btn ${showAll ? "btn-primary" : "btn-secondary"}`}
					>
						{showAll ? "Show Less" : `Show All ${responsesList.length} Responses`}
					</button>
				</div>
			)}

			<div className="chart-footer">Total Responses: {responsesList.length}</div>
		</div>
	);
};

export default OpenEndedResponses;
